import { render, staticRenderFns } from "./glassOffcutList.vue?vue&type=template&id=2561c6ba&"
import script from "./glassOffcutList.vue?vue&type=script&lang=js&"
export * from "./glassOffcutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports